import { stringify } from './stringify.js';
function defaultGetId() {
  return 'none';
}
/**
 * @name memoize
 * @description Memomize the function with a specific instanceId
 */
export function memoize(fn) {
  let {
    getInstanceId = defaultGetId
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const cache = {};
  const memoized = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const stringParams = stringify(args);
    const instanceId = getInstanceId();
    if (!cache[instanceId]) {
      cache[instanceId] = {};
    }
    if (cache[instanceId][stringParams] === undefined) {
      cache[instanceId][stringParams] = fn(...args);
    }
    return cache[instanceId][stringParams];
  };
  memoized.unmemoize = function () {
    var _cache$instanceId;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    const stringParams = stringify(args);
    const instanceId = getInstanceId();
    if (((_cache$instanceId = cache[instanceId]) === null || _cache$instanceId === void 0 ? void 0 : _cache$instanceId[stringParams]) !== undefined) {
      delete cache[instanceId][stringParams];
    }
  };
  return memoized;
}